'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('teleportTo', ['teleportService', function (teleportService) {
    return {
        restrict: 'E', //Element-only usage
        transclude: true, // Accept HTML contents of the element
        link: function link($scope, $element, $attrs, controller, $transclude) {
            $element.on('$destroy', function () {
                var target = teleportService.getTarget($attrs['to']);
                target.empty();
                target.removeClass('teleport-with-content');
            });
            $transclude($scope, function (clone) {
                var target = teleportService.getTarget($attrs['to']);
                target.empty();
                target.append(clone);
                target.addClass('teleport-with-content');
            });
        }
    };
}]); // Teleport source for "cross-transclusion", i.e. when you want to make content 
// visible somewhere else entirely on the page. (e.g. when you want to show 
// stuff below the left menu but the content is present only in the page code.


//////////////////
// WEBPACK FOOTER
// ./src/core/teleportTo.js
// module id = 57
// module chunks = 0 2